(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_a-pdp-controls"] && !Shopify.designMode) return;
  try {
    /*****************************************
	 * Shared helpers (this block only)
	 *****************************************/
	const l_pControlsParseInt = (value, fallback = 0) => {
		const parsed = parseInt(value, 10)
		return Number.isNaN(parsed) ? fallback : parsed
	}

	/*****************************************
	 * [COMPONENT]: l-product-form — ATC
	 * Public API used by a-main-product:
	 *   handleErrorMessage(), global_toggleSubmitButton()
	 *****************************************/
	if (!customElements.get('l-product-form')) {
		class LTAProductForm extends HTMLElement {
			constructor() {
				super()
				this._onSubmit = this._onSubmit.bind(this)
				this._onVariantChange = this._onVariantChange.bind(this)
				this._cleanups = []
				this._errorClearTimer = null
			}

			/* ---------------------------------
			 * Lifecycle
			 * --------------------------------- */
			connectedCallback() {
				this._cacheElements()
				this.error = false

				this.form?.addEventListener('submit', this._onSubmit)
				document.addEventListener('l:variant:changed', this._onVariantChange)

				this._cleanups.push(
					() => this.form?.removeEventListener('submit', this._onSubmit),
					() => document.removeEventListener('l:variant:changed', this._onVariantChange)
				)
			}

			disconnectedCallback() {
				clearTimeout(this._errorClearTimer)
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
			}

			_cacheElements() {
				this.form = this.querySelector('form') || document.getElementById(this.dataset.formId)
				this.submitButtonEl = this.querySelector('[type="submit"]')
				this.submitButtonTextEl = this.submitButtonEl?.querySelector('[data-add-to-cart-label]')
				this.dynamicCheckoutEl = this.querySelector('[data-dynamic-checkout]')
				this.sectionId = this.dataset.sectionId
				this.productId = this.dataset.productId
				this.hideErrors = this.dataset.hideErrors === 'true'
			}

			_cacheSubmitButtonRefs() {
				this.submitButtonEl = this.querySelector('[type="submit"]')
				this.submitButtonTextEl = this.submitButtonEl?.querySelector('[data-add-to-cart-label]')
			}

			/* ---------------------------------
			 * Variant swap (section HTML)
			 * --------------------------------- */
			_onVariantChange(event) {
				const { sectionId, html, productId, variant } = event.detail || {}
				if (productId !== this.productId || sectionId !== this.sectionId) return

				this.dynamicCheckoutEl?.classList.toggle('l-hidden', !variant)

				if (!variant) {
					this.global_toggleSubmitButton(true, 'unavailable')
					return
				}

				const newSubmitButtonEl = html.getElementById(`ProductSubmitButton-${this.sectionId}`)
				if (!newSubmitButtonEl || !this.submitButtonEl) return

				this.submitButtonEl.replaceWith(newSubmitButtonEl)
				this._cacheSubmitButtonRefs()
			}

			/* ---------------------------------
			 * Add to cart
			 * --------------------------------- */
			_onSubmit(evt) {
				evt.preventDefault()
				if (!this.submitButtonEl || this.submitButtonEl.getAttribute('aria-disabled') === 'true') return
				if (!this._prepareLineItemProperties()) return

				this._setSubmitLoading(true)

				ltaCartService
					.addToCart(ltaCartService.createConfigFromForm(this.form), 'l-product-form')
					.then((response) => {
						this.handleErrorMessage(response?.status ? response.description : false)
					})
					.catch((e) => {
						console.error('Add to cart error:', e)
					})
					.finally(() => {
						this._setSubmitLoading(false)
						this._scheduleErrorClear()
					})
			}

			_prepareLineItemProperties() {
				const scope = this.closest('l-product-info') || document
				const emptyOptional = []
				let firstInvalidEl = null

				scope.querySelectorAll('[data-line-prop-host]').forEach((host) => {
					const fields = Array.from(host.querySelectorAll('[data-line-prop-field]'))
					const required = host.dataset.required === 'true'
					const empty = this._linePropFieldsEmpty(host, fields)

					if (required && empty) {
						this._setLinePropInvalid(host, fields, true)
						if (!firstInvalidEl) firstInvalidEl = fields[0] || host
						return
					}

					this._setLinePropInvalid(host, fields, false)
					if (required) return

					fields.forEach((el) => {
						if (el.disabled || !this._linePropFieldEmpty(el)) return
						el.disabled = true
						emptyOptional.push(el)
					})
				})

				queueMicrotask(() => {
					emptyOptional.forEach((el) => {
						el.disabled = false
					})
				})

				if (!firstInvalidEl) return true
				firstInvalidEl.focus()
				return false
			}

			_linePropFieldsEmpty(host, fields) {
				if (!fields.length) return true
				if (host.dataset.fieldType === 'checkbox' || host.dataset.fieldType === 'radio') {
					return !fields.some((el) => el.checked)
				}
				return fields.every((el) => this._linePropFieldEmpty(el))
			}

			_linePropFieldEmpty(el) {
				if (el.type === 'checkbox' || el.type === 'radio') return !el.checked
				return !String(el.value || '').trim()
			}

			_setLinePropInvalid(host, fields, invalid) {
				host.toggleAttribute('data-invalid', invalid)

				const errorEl = host.querySelector('[data-line-prop-error]')
				if (errorEl) {
					errorEl.classList.toggle('l-hidden', !invalid)
					errorEl.textContent = invalid ? host.dataset.requiredMessage : ''
				}

				fields.forEach((el) => {
					el.setAttribute('aria-invalid', invalid ? 'true' : 'false')
					if (invalid && errorEl?.id) el.setAttribute('aria-describedby', errorEl.id)
					else el.removeAttribute('aria-describedby')
				})
			}

			_setSubmitLoading(isLoading) {
				if (!this.submitButtonEl) return

				this.submitButtonEl.classList.toggle('is-loading', isLoading)
				this.submitButtonEl.classList.toggle('l-button-loading', isLoading)

				if (isLoading) {
					this.submitButtonEl.setAttribute('aria-disabled', true)
					return
				}

				this.submitButtonEl.removeAttribute('aria-disabled')
			}

			_scheduleErrorClear() {
				clearTimeout(this._errorClearTimer)
				if (!this.error) return
				this._errorClearTimer = setTimeout(() => this.handleErrorMessage(false), 1000)
			}

			/* ---------------------------------
			 * Public — a-main-product hooks
			 * --------------------------------- */
			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return

				if (!this.errorMessageWrapper) {
					this.errorMessageWrapper = document.getElementById(`ProductErrorMessages-${this.sectionId}`)
					this.errorMessage = this.errorMessageWrapper?.querySelector('[data-error-message]')
				}

				if (!this.errorMessageWrapper) return

				this.error = Boolean(errorMessage)
				this.errorMessageWrapper.classList.toggle('l-hidden', !errorMessage)
				if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage
			}

			global_toggleSubmitButton(disable = true, textType, needToUpdateText = true) {
				if (!this.submitButtonEl) return

				this.submitButtonEl.toggleAttribute('disabled', disable)

				if (needToUpdateText && this.submitButtonTextEl) {
					this.submitButtonTextEl.textContent = this._getButtonLabel(textType)
				}
			}

			_getButtonLabel(textType = 'addToCart') {
				const strings = window.LTATheme.variantStrings
				switch (textType) {
					case 'soldOut':
						return strings.soldOut
					case 'unavailable':
						return strings.unavailable
					case 'preOrder':
					default:
						return strings.addToCart
				}
			}
		}

		customElements.define('l-product-form', LTAProductForm)
	}

	/*****************************************
	 * [COMPONENT]: l-line-item-property — clear required error on input
	 *****************************************/
	if (!customElements.get('l-line-item-property')) {
		class LTALineItemProperty extends HTMLElement {
			constructor() {
				super()
				this._onFieldChange = this._onFieldChange.bind(this)
				this._cleanups = []
			}

			connectedCallback() {
				this.addEventListener('input', this._onFieldChange)
				this.addEventListener('change', this._onFieldChange)
				this._cleanups.push(
					() => this.removeEventListener('input', this._onFieldChange),
					() => this.removeEventListener('change', this._onFieldChange)
				)
			}

			disconnectedCallback() {
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
			}

			_onFieldChange() {
				if (!this.hasAttribute('data-invalid')) return
				if (this.dataset.required === 'true' && this._isEmpty()) return
				this._clearInvalid()
			}

			_isEmpty() {
				const fields = Array.from(this.querySelectorAll('[data-line-prop-field]'))
				if (!fields.length) return true
				if (this.dataset.fieldType === 'checkbox' || this.dataset.fieldType === 'radio') {
					return !fields.some((el) => el.checked)
				}
				return fields.every((el) => {
					if (el.type === 'checkbox' || el.type === 'radio') return !el.checked
					return !String(el.value || '').trim()
				})
			}

			_clearInvalid() {
				this.toggleAttribute('data-invalid', false)

				const errorEl = this.querySelector('[data-line-prop-error]')
				if (errorEl) {
					errorEl.classList.add('l-hidden')
					errorEl.textContent = ''
				}

				this.querySelectorAll('[data-line-prop-field]').forEach((el) => {
					el.setAttribute('aria-invalid', 'false')
					el.removeAttribute('aria-describedby')
				})
			}
		}

		customElements.define('l-line-item-property', LTALineItemProperty)
	}

	/*****************************************
	 * [COMPONENT]: l-pdp-qty-input
	 * Extends l-qty-input — cart-aware max (Dawn D1) + variant sync
	 *****************************************/
	customElements.whenDefined('l-qty-input').then(() => {
		if (customElements.get('l-pdp-qty-input')) return

		class LTAPdpQtyInput extends customElements.get('l-qty-input') {
			constructor() {
				super()
				this._onQtyChange = this._onQtyChange.bind(this)
				this._onVariantChange = this._onVariantChange.bind(this)
			}

			/* ---------------------------------
			 * Lifecycle
			 * --------------------------------- */
			connectedCallback() {
				super.connectedCallback()

				this.productId = this.dataset.productId
				this.sectionId = this.dataset.sectionId

				this._applyQuantityBoundaries()
				this.addEventListener('change', this._onQtyChange)
				document.addEventListener('l:variant:changed', this._onVariantChange)
			}

			disconnectedCallback() {
				this.removeEventListener('change', this._onQtyChange)
				document.removeEventListener('l:variant:changed', this._onVariantChange)
				super.disconnectedCallback()
			}

			_getInput() {
				return this.input || this.querySelector('[data-qty-input]')
			}

			/* ---------------------------------
			 * Qty boundaries
			 * data-max = absolute quantity_rule.max
			 * effective max = data-max - data-cart-quantity
			 * Inventory-only max (no data-max) stays as Liquid remaining stock
			 * --------------------------------- */
			_applyQuantityBoundaries() {
				const input = this._getInput()
				if (!input) return

				const cartQuantity = l_pControlsParseInt(input.dataset.cartQuantity, 0)
				const step = l_pControlsParseInt(input.step, 1)
				const ruleMin = l_pControlsParseInt(input.dataset.min || input.min, 1)
				let min = ruleMin

				const dataMaxRaw = input.dataset.max
				const hasRuleMax = dataMaxRaw !== undefined && dataMaxRaw !== ''
				const dataMax = hasRuleMax ? l_pControlsParseInt(dataMaxRaw, NaN) : null

				if (dataMax !== null && !Number.isNaN(dataMax)) {
					const max = dataMax - cartQuantity
					if (max >= 0) {
						input.max = String(max)
						min = Math.min(min, max)
					} else {
						input.removeAttribute('max')
					}
				}

				if (cartQuantity >= ruleMin) min = Math.min(min, step)

				input.min = String(Math.max(0, min))
				this.validateQtyRules?.()
			}

			/* ---------------------------------
			 * Events
			 * --------------------------------- */
			_onQtyChange(event) {
				const input = this._getInput()
				if (!input || event.target !== input) return

				input.dispatchEvent(
					new CustomEvent('l:quantity:changed', {
						bubbles: true,
						detail: {
							quantity: l_pControlsParseInt(input.value, 0),
							productId: this.productId,
							sectionId: this.sectionId,
						},
					})
				)
			}

			_onVariantChange(event) {
				const { html, sectionId, productId, variant } = event.detail || {}
				if (productId !== this.productId || sectionId !== this.sectionId || !variant) return

				const newInputEl = html.getElementById(`Product-Form-Controls-${sectionId}`)?.querySelector('[data-qty-input]')
				const input = this._getInput()
				if (!newInputEl || !input) return

				this._syncQtyInputFromSection(input, newInputEl)
				this._applyQuantityBoundaries()
				input.dispatchEvent(new Event('change', { bubbles: true }))
			}

			_syncQtyInputFromSection(input, source) {
				input.value = source.value
				input.step = source.step
				input.dataset.min = source.dataset.min || String(source.min || 1)
				input.dataset.cartQuantity = source.dataset.cartQuantity || '0'
				input.toggleAttribute('disabled', source.disabled)

				if (source.dataset.max) {
					input.dataset.max = source.dataset.max
					input.setAttribute('max', source.getAttribute('max') || source.dataset.max)
					return
				}

				delete input.dataset.max
				if (source.max !== '') {
					input.max = source.max
				} else {
					input.removeAttribute('max')
				}
			}
		}

		customElements.define('l-pdp-qty-input', LTAPdpQtyInput)
	})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_a-pdp-inventory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-pdp-inventory')) {
		class LTAPdpInventory extends HTMLElement {
			constructor() {
				super()
				this._boundOnVariantChange = this._onVariantChange.bind(this)
			}

			connectedCallback() {
				this.sectionId = this.dataset.sectionId
				this.productId = this.dataset.productId
				document.addEventListener('l:variant:changed', this._boundOnVariantChange)
			}

			disconnectedCallback() {
				document.removeEventListener('l:variant:changed', this._boundOnVariantChange)
			}

			_onVariantChange(event) {
				const { sectionId, html, productId, variant } = event.detail || {}
				if (productId !== this.productId || sectionId !== this.sectionId) return

				const source = html.getElementById(`inventory-${sectionId}`)
				if (!source || !variant) {
					this.toggleAttribute('data-empty', true)
					this.removeAttribute('data-status')
					return
				}

				this.innerHTML = source.innerHTML
				this.toggleAttribute('data-empty', source.hasAttribute('data-empty'))
				if (source.hasAttribute('data-status')) {
					this.dataset.status = source.dataset.status
				} else {
					this.removeAttribute('data-status')
				}
			}
		}

		customElements.define('l-pdp-inventory', LTAPdpInventory)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_a-pdp-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-pdp-price')) {
		class LTAPdpPrice extends HTMLElement {
			constructor() {
				super()
				this._boundOnVariantChange = this._onVariantChange.bind(this)
			}

			connectedCallback() {
				this.sectionId = this.dataset.sectionId
				this.productId = this.dataset.productId
				this._applyInstallmentsFont()
				document.addEventListener('l:variant:changed', this._boundOnVariantChange)
			}

			disconnectedCallback() {
				document.removeEventListener('l:variant:changed', this._boundOnVariantChange)
				this._installmentsObserver?.disconnect()
			}

			_applyInstallmentsFont() {
				const inject = (el, retries = 10) => {
					if (!el.shadowRoot) {
						if (retries > 0) requestAnimationFrame(() => inject(el, retries - 1))
						return
					}
					if (el.shadowRoot.getElementById('l-installments-font')) return
					const style = document.createElement('style')
					style.id = 'l-installments-font'
					style.textContent = `* { font-family: inherit !important; }`
					el.shadowRoot.appendChild(style)
				}

				const installmentsEl = this.querySelector('[data-installments]')
				if (!installmentsEl) return

				const el = installmentsEl.querySelector('shopify-payment-terms')
				if (el) return inject(el)

				this._installmentsObserver?.disconnect()
				this._installmentsObserver = new MutationObserver(() => {
					const target = installmentsEl.querySelector('shopify-payment-terms')
					if (target) {
						inject(target)
						this._installmentsObserver.disconnect()
					}
				})
				this._installmentsObserver.observe(installmentsEl, { childList: true, subtree: true })
			}

			_onVariantChange(event) {
				const { sectionId, html, productId, variant } = event.detail || {}
				if (productId !== this.productId || sectionId !== this.sectionId) return

				const unavailable = !variant
				this.classList.toggle('l-hidden', unavailable)
				this.setAttribute('aria-hidden', unavailable ? 'true' : 'false')
				if (unavailable) return

				const source = html.getElementById(`price-${sectionId}`)
				if (source) {
					this.innerHTML = source.innerHTML
					this._applyInstallmentsFont()
				}
			}
		}

		customElements.define('l-pdp-price', LTAPdpPrice)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_a-pdp-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-sticky-atc')) {
		class LTAStickyAtc extends HTMLElement {
			constructor() {
				super()
				this._onAtcClick = this._onAtcClick.bind(this)
				this._onQuantityChange = this._onQuantityChange.bind(this)
				this._onSellingPlanChanged = this._onSellingPlanChanged.bind(this)
				this._onVariantChanged = this._onVariantChanged.bind(this)
				this._cleanups = []
				this._observer = null
			}

			connectedCallback() {
				if (this.parentElement !== document.body) {
					document.body.appendChild(this)
					return
				}

				this._cache()
				this._bind()
				this._renderMeta()
				this._observeSubmit()
			}

			disconnectedCallback() {
				this._observer?.disconnect()
				this._observer = null
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
			}

			_cache() {
				this.sectionId = this.dataset.sectionId
				this.productId = this.dataset.productId
				this.formId = this.dataset.formId
				this.submitId = this.dataset.submitId
				this.atcButtonEl = this.querySelector('[data-sticky-atc]')
				this.planEl = this.querySelector('[data-sticky-plan]')
				this.totalEl = this.querySelector('[data-sticky-total]')
				this.atcPriceEl = this.querySelector('[data-sticky-atc-price]')
				this.metaEl = this.querySelector('[data-sticky-meta]')
				this.metaPriceEl = this.querySelector('[data-sticky-meta-price]')
				this.qty = Number(this.dataset.qty) || 1
				this.subscribeSelected = this.dataset.subscribeSelected === 'true'
				this.hasSellingPlans = this.dataset.hasSellingPlans === 'true'

				const qtyInput = document.getElementById(this.formId)?.querySelector('[data-qty-input], [name="quantity"]')
				const liveQty = Number(qtyInput?.value)

				if (liveQty > 0) {
					this.qty = liveQty
					this.dataset.qty = String(liveQty)
				}
			}

			_bind() {
				this.atcButtonEl?.addEventListener('click', this._onAtcClick)
				document.addEventListener('l:quantity:changed', this._onQuantityChange)
				document.addEventListener('l:sellingPlan:changed', this._onSellingPlanChanged)
				document.addEventListener('l:variant:changed', this._onVariantChanged)

				this._cleanups.push(
					() => this.atcButtonEl?.removeEventListener('click', this._onAtcClick),
					() => document.removeEventListener('l:quantity:changed', this._onQuantityChange),
					() => document.removeEventListener('l:sellingPlan:changed', this._onSellingPlanChanged),
					() => document.removeEventListener('l:variant:changed', this._onVariantChanged)
				)
			}

			_observeSubmit() {
				this._observer?.disconnect()
				this._observer = null

				if (window.Shopify?.designMode) {
					this._setVisible(true)
					return
				}

				const submitEl = document.getElementById(this.submitId)

				if (!submitEl) {
					this._setVisible(false)
					return
				}

				const update = () => {
					const rect = submitEl.getBoundingClientRect()
					const inView =
						rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth

					this._setVisible(!inView)
				}

				this._observer = new IntersectionObserver(
					([entry]) => {
						this._setVisible(!(entry?.isIntersecting && entry.intersectionRatio > 0))
					},
					{ threshold: [0, 0.01, 1], rootMargin: '0px' }
				)
				this._observer.observe(submitEl)
				update()
			}

			_setVisible(visible) {
				this.toggleAttribute('data-visible', Boolean(visible))
				this.toggleAttribute('inert', !visible)
			}

			_onAtcClick(event) {
				event.preventDefault()
				if (this.atcButtonEl?.disabled) return

				const submitEl = document.getElementById(this.submitId)

				if (submitEl && !submitEl.disabled && submitEl.getAttribute('aria-disabled') !== 'true') {
					submitEl.click()
					return
				}

				const form = document.getElementById(this.formId)

				if (form?.requestSubmit) form.requestSubmit()
			}

			_onQuantityChange(event) {
				const { sectionId, productId, quantity } = event.detail || {}

				if (productId !== this.productId || sectionId !== this.sectionId) return

				this.qty = quantity || 1
				this.dataset.qty = String(this.qty)
				this._renderMeta()
			}

			_onSellingPlanChanged(event) {
				const { sectionId, productId, sellingPlanId, target } = event.detail || {}

				if (productId !== this.productId || sectionId !== this.sectionId) return

				const subscribeSelected =
					Boolean(sellingPlanId) || target?.querySelector?.('[data-purchase-option="subscribe"]')?.checked

				this.subscribeSelected = Boolean(subscribeSelected) && this.hasSellingPlans
				this.dataset.subscribeSelected = this.subscribeSelected ? 'true' : 'false'
				this._renderMeta()
			}

			_onVariantChanged(event) {
				const { sectionId, productId } = event.detail || {}

				if (productId !== this.productId || sectionId !== this.sectionId) return

				requestAnimationFrame(() => this._observeSubmit())
			}

			_unitPrice() {
				const onetime = Number(this.dataset.onetimePrice) || 0
				const subscribe = Number(this.dataset.subscribePrice) || onetime

				return this.subscribeSelected ? subscribe : onetime
			}

			_planLabel() {
				if (!this.hasSellingPlans) return ''

				return this.subscribeSelected ? this.dataset.subscribeLabel || '' : this.dataset.onetimeLabel || ''
			}

			_renderMeta() {
				const plan = this._planLabel()
				const total = this._formatMoney(this._unitPrice() * this.qty)

				if (this.planEl) {
					this.planEl.textContent = plan
					this.planEl.hidden = !plan
				}

				if (this.metaPriceEl) {
					const sep = this.metaPriceEl.querySelector('[aria-hidden="true"]')

					if (sep) sep.hidden = !plan
				}

				if (this.totalEl) this.totalEl.textContent = total
				if (this.atcPriceEl) this.atcPriceEl.textContent = total
			}

			_formatMoney(cents) {
				const value = Math.round(Number(cents) || 0)

				if (typeof window.l_formatMoney === 'function') {
					return String(window.l_formatMoney(value)).replace(/"/g, '')
				}

				return String(value / 100)
			}
		}

		customElements.define('l-sticky-atc', LTAStickyAtc)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_a-pdp-subscriptions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-subscriptions-selling-plans')) {
		class LTASubscriptionSellingPlans extends HTMLElement {
			constructor() {
				super()
				this._onChange = this._onChange.bind(this)
				this._onVariantChange = this._onVariantChange.bind(this)
				this._onQuantityChange = this._onQuantityChange.bind(this)
				this._onSealWidgetCreated = this._onSealWidgetCreated.bind(this)
				this._cleanups = []
			}

			connectedCallback() {
				this._cache()
				this._bind()
				this._disableAppInputs()
			}

			disconnectedCallback() {
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
			}

			_cache() {
				this.saveLabelEl = this.querySelector('[data-save-label]')
				this.variantPriceEl = this.querySelector('[data-variant-price]')
				this.sellingPriceEl = this.querySelector('[data-selling-price]')
				this.planControlEl = this.querySelector('[data-selling-plan-select]')
				this.onetimePlanEl = this.querySelector('[data-onetime-selling-plan]')
				this.productId = this.dataset.productId
				this.sectionId = this.dataset.sectionId

				const script = this.querySelector('script[type="application/json"]')
				this.subscriptionData = script ? JSON.parse(script.textContent) : {}
				this.selectedVariantId = this.subscriptionData?.id
			}

			_bind() {
				this.addEventListener('change', this._onChange)
				document.addEventListener('l:variant:changed', this._onVariantChange)
				document.addEventListener('l:quantity:changed', this._onQuantityChange)
				this._cleanups.push(
					() => this.removeEventListener('change', this._onChange),
					() => document.removeEventListener('l:variant:changed', this._onVariantChange),
					() => document.removeEventListener('l:quantity:changed', this._onQuantityChange)
				)
			}

			_syncPlanControls() {
				const subscribeSelected = this.querySelector('[data-purchase-option="subscribe"]')?.checked

				if (this.planControlEl) this.planControlEl.disabled = !subscribeSelected
				if (this.onetimePlanEl) this.onetimePlanEl.disabled = Boolean(subscribeSelected)
			}

			_selectedSellingPlanId() {
				const subscribeSelected = this.querySelector('[data-purchase-option="subscribe"]')?.checked

				if (!subscribeSelected) return ''

				return this.planControlEl?.value || ''
			}

			_onChange(event) {
				const target = event.target
				const isPurchase = target?.hasAttribute('data-purchase-option')
				const isPlan =
					target?.hasAttribute('data-selling-plan-select') || target?.hasAttribute('data-onetime-selling-plan')

				if (!isPurchase && !isPlan) return

				this._syncPlanControls()
				this._dispatchSellingPlanChanged()
			}

			_dispatchSellingPlanChanged() {
				this.dispatchEvent(
					new CustomEvent('l:sellingPlan:changed', {
						bubbles: true,
						detail: {
							sellingPlanId: this._selectedSellingPlanId(),
							productId: this.productId,
							sectionId: this.sectionId,
							selectedVariantId: this.selectedVariantId,
							target: this,
						},
					})
				)
			}

			_onQuantityChange(event) {
				const { sectionId, productId, quantity } = event.detail

				if (productId !== this.productId || sectionId !== this.sectionId) return

				this.subscriptionData = {
					...this.subscriptionData,
					quantity,
				}

				const { variantPrice, sellingPlanPrice, sellingPlanCompareAtPrice, priceAdjustmentType, saveLabel } =
					this.subscriptionData
				const qty = quantity || 1

				if (this.variantPriceEl) this.variantPriceEl.innerHTML = l_formatMoney(variantPrice * qty).replace(/"/g, '')
				if (this.sellingPriceEl) this.sellingPriceEl.innerHTML = l_formatMoney(sellingPlanPrice * qty).replace(/"/g, '')

				if (priceAdjustmentType == 'price' && this.saveLabelEl && saveLabel) {
					const reducedPrice = l_formatMoney((sellingPlanCompareAtPrice - sellingPlanPrice) * qty).replace(/"/g, '')
					this.saveLabelEl.innerHTML = saveLabel.replace('[save_amount]', reducedPrice)
				}
			}

			_onVariantChange(event) {
				const { sectionId, html, productId, variant } = event.detail

				if (productId !== this.productId || sectionId !== this.sectionId) return

				const newSubscriptionsEl = html?.getElementById?.(`Subscriptions-${this.sectionId}`)

				if (newSubscriptionsEl) {
					this.innerHTML = newSubscriptionsEl.innerHTML
					this.classList.toggle('l-hidden', newSubscriptionsEl.classList.contains('l-hidden'))
					this._cache()
					return
				}

				this.classList.toggle('l-hidden', !variant)
			}

			_disableAppInputs() {
				document.addEventListener('sealsubs:subscription_widget_created', this._onSealWidgetCreated)
				this._cleanups.push(() =>
					document.removeEventListener('sealsubs:subscription_widget_created', this._onSealWidgetCreated)
				)
			}

			_onSealWidgetCreated() {
				const productEl = document.getElementById('product')
				if (!productEl) return

				productEl.querySelectorAll('.sealsubs-target-element').forEach((sealEl) => {
					sealEl.classList.add('l-hidden')
					sealEl.querySelectorAll('[name="selling_plan"]').forEach((input) => {
						input.setAttribute('disabled', 'disabled')
					})
				})
			}
		}

		customElements.define('l-subscriptions-selling-plans', LTASubscriptionSellingPlans)
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_a-pdp-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-variant-selects')) {
		/* Survives l-variant-selects HTML swaps on variant change */
		const optionListExpandState = new Map()

		class LTAVariantSelect extends HTMLElement {
			constructor() {
				super()
				this._onChange = this._onChange.bind(this)
				this._onOptionMoreClick = this._onOptionMoreClick.bind(this)
				this._onClipTransitionEnd = this._onClipTransitionEnd.bind(this)
				this._cleanups = []
			}

			/* ---------------------------------
			 * Lifecycle
			 * --------------------------------- */

			connectedCallback() {
				this.productId = this.dataset.productId
				this.sectionId = this.dataset.sectionId
				this.liveEl = this.querySelector('[data-variant-live]')
				this.announceTemplate = this.dataset.announceSelected || '__NAME__: __VALUE__'
				this._reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

				this.addEventListener('change', this._onChange)
				this._cleanups.push(() => this.removeEventListener('change', this._onChange))

				this._initOptionLists()
			}

			disconnectedCallback() {
				this._runCleanups()
			}

			/* ---------------------------------
			 * Option list show more / less
			 * --------------------------------- */

			_optionListStateKey(optionName) {
				return `${this.sectionId}:${this.productId}:${optionName}`
			}

			_getOptionName(listEl) {
				return listEl.closest('[data-option-name]')?.dataset.optionName || ''
			}

			_rememberOptionListExpanded(clipEl, expanded) {
				const optionName = this._getOptionName(clipEl)
				if (!optionName) return
				optionListExpandState.set(this._optionListStateKey(optionName), expanded)
			}

			_optionItems(clipEl) {
				return [...(clipEl.querySelector('[data-option-list]')?.children || [])]
			}

			_overflowItems(clipEl) {
				return this._optionItems(clipEl).filter((el) => el.hasAttribute('data-option-overflow'))
			}

			/* Hide Show more when there is nothing to reveal */
			_syncMoreButton(clipEl, moreBtn) {
				const needsMore = this._overflowItems(clipEl).length > 0
				moreBtn.hidden = !needsMore
				clipEl.toggleAttribute('data-clamped', needsMore)
				if (!needsMore) {
					clipEl.toggleAttribute('data-expanded', true)
					clipEl.style.height = 'auto'
					clipEl.removeAttribute('data-animating')
				}
				return needsMore
			}

			_applyOptionListExpanded(clipEl, moreBtn, expanded) {
				if (!this._syncMoreButton(clipEl, moreBtn)) return

				clipEl.toggleAttribute('data-expanded', expanded)
				moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false')
				moreBtn.textContent = expanded ? moreBtn.dataset.labelLess : moreBtn.dataset.labelMore
				clipEl.style.height = 'auto'
				clipEl.removeAttribute('data-animating')
			}

			_initOptionLists() {
				this.querySelectorAll('[data-option-clip]').forEach((clipEl) => {
					const moreBtn = clipEl.parentElement?.querySelector('[data-option-more]')
					if (!moreBtn) return

					moreBtn.addEventListener('click', this._onOptionMoreClick)
					clipEl.addEventListener('transitionend', this._onClipTransitionEnd)
					this._cleanups.push(
						() => moreBtn.removeEventListener('click', this._onOptionMoreClick),
						() => clipEl.removeEventListener('transitionend', this._onClipTransitionEnd)
					)

					const optionName = this._getOptionName(clipEl)
					const stateKey = this._optionListStateKey(optionName)
					const hasStoredState = optionName && optionListExpandState.has(stateKey)
					const expanded = hasStoredState ? optionListExpandState.get(stateKey) : clipEl.hasAttribute('data-expanded')

					this._applyOptionListExpanded(clipEl, moreBtn, expanded)
				})
			}

			_onOptionMoreClick(event) {
				const moreBtn = event.currentTarget
				const clipEl = moreBtn.parentElement?.querySelector('[data-option-clip]')
				if (!clipEl || moreBtn.hidden) return

				if (clipEl.hasAttribute('data-expanded')) this._collapseOptionList(clipEl, moreBtn)
				else this._expandOptionList(clipEl, moreBtn)
			}

			_expandOptionList(clipEl, moreBtn) {
				const startHeight = clipEl.getBoundingClientRect().height

				moreBtn.setAttribute('aria-expanded', 'true')
				moreBtn.textContent = moreBtn.dataset.labelLess
				this._rememberOptionListExpanded(clipEl, true)

				if (this._reduceMotion) {
					clipEl.toggleAttribute('data-expanded', true)
					clipEl.style.height = 'auto'
					return
				}

				clipEl.toggleAttribute('data-animating', true)
				clipEl.style.height = `${startHeight}px`
				clipEl.toggleAttribute('data-expanded', true)
				const endHeight = clipEl.scrollHeight
				clipEl.offsetHeight
				clipEl.style.height = `${endHeight}px`
			}

			_collapseOptionList(clipEl, moreBtn) {
				const startHeight = clipEl.getBoundingClientRect().height
				const endHeight = this._measureCollapsedHeight(clipEl)

				moreBtn.setAttribute('aria-expanded', 'false')
				moreBtn.textContent = moreBtn.dataset.labelMore
				this._rememberOptionListExpanded(clipEl, false)

				if (this._reduceMotion) {
					clipEl.removeAttribute('data-expanded')
					clipEl.style.height = 'auto'
					return
				}

				clipEl.toggleAttribute('data-animating', true)
				clipEl.style.height = `${startHeight}px`
				clipEl.offsetHeight
				clipEl.removeAttribute('data-expanded')
				clipEl.style.height = `${endHeight}px`
			}

			_onClipTransitionEnd(event) {
				if (event.propertyName !== 'height') return
				const clipEl = event.currentTarget
				clipEl.style.height = 'auto'
				clipEl.removeAttribute('data-animating')
			}

			/* Height of first visible values only (overflow items still in layout while expanded) */
			_measureCollapsedHeight(clipEl) {
				const items = this._optionItems(clipEl)
				const visible = items.filter((el) => !el.hasAttribute('data-option-overflow'))
				if (!visible.length) return 0

				const clipTop = clipEl.getBoundingClientRect().top
				const lastVisible = visible[visible.length - 1]
				return Math.ceil(lastVisible.getBoundingClientRect().bottom - clipTop)
			}

			/* ---------------------------------
			 * Events
			 * --------------------------------- */

			_onChange(event) {
				const inputEl = this._resolveInputEl(event.target)
				this._syncSelectedLabel(inputEl)
				this._announceSelection(event.target, inputEl)
				this._dispatchOptionChanged(event, inputEl)
			}

			/* ---------------------------------
			 * UI sync
			 * --------------------------------- */

			/* Pill/swatch legends: "Color: Red" */
			_syncSelectedLabel(inputEl) {
				if (!inputEl?.hasAttribute('data-product-variant-input')) return

				const labelEl = inputEl.closest('[data-variant-options]')?.querySelector('[data-selected-value]')
				if (labelEl) labelEl.textContent = inputEl.value
			}

			/* aria-live: "Color: Red" */
			_announceSelection(eventTarget, inputEl) {
				if (!this.liveEl || !inputEl) return

				const optionRoot = inputEl.closest('[data-option-name]') || eventTarget?.closest?.('[data-option-name]')
				const optionName = optionRoot?.dataset.optionName || ''
				const optionValue = inputEl.value || inputEl.dataset?.optionValue || ''
				if (!optionValue) return

				this.liveEl.textContent = this.announceTemplate
					.replace('__NAME__', optionName)
					.replace('__VALUE__', optionValue)
			}

			/* ---------------------------------
			 * Helpers
			 * --------------------------------- */

			/* SELECT → selected <option>; radio → input itself */
			_resolveInputEl(eventTarget) {
				return eventTarget.tagName === 'SELECT' ? eventTarget.selectedOptions[0] : eventTarget
			}

			/* Dropdown → trigger; pills → radio id (survives section HTML swap) */
			_getFocusTargetId(eventTarget, inputEl) {
				if (eventTarget?.tagName === 'SELECT') {
					const trigger = eventTarget.closest('l-custom-select')?.querySelector('[data-trigger]')
					return trigger?.id || eventTarget.id || null
				}

				return inputEl?.id || null
			}

			_dispatchOptionChanged(event, inputEl) {
				document.dispatchEvent(
					new CustomEvent('l:variant:option-changed', {
						detail: {
							event,
							target: inputEl,
							focusTargetId: this._getFocusTargetId(event.target, inputEl),
							selectedOptionValues: this.selectedOptionValues,
							productId: this.productId,
							sectionId: this.sectionId,
						},
					})
				)
			}

			_runCleanups() {
				this._cleanups.forEach((fn) => {
					try {
						fn()
					} catch {}
				})
				this._cleanups = []
			}

			/* ---------------------------------
			 * Getters
			 * --------------------------------- */

			get selectedOptionValues() {
				return Array.from(
					this.querySelectorAll('[data-variant-select] option[selected], [data-product-variant-input]:checked')
				).map((el) => el.dataset.optionValueId)
			}
		}

		customElements.define('l-variant-selects', LTAVariantSelect)
	}
  } catch(e) { console.error(e); }
})();

})();
